import { IconButton } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

const BackButton = ({ navigateTo }: { navigateTo?: string }) => {
  const navigate = useNavigate();
  const handleGoBack = () =>
    typeof navigateTo === 'string' ? navigate(navigateTo) : navigate(-1);
  return (
    <IconButton onClick={handleGoBack}>
      <ChevronLeftIcon />
    </IconButton>
  );
};

export default BackButton;
